<template>
  <Modal @close="close" @confirm="confirm">
    <template #body>
      <div class="d-flex justify-content-around mb-4">
        <Logo logo="oops" :size="100" />
      </div>
      <div class="apology mb-4">{{ $t("global.free-trial-oops") }}</div>
    </template>
    <template #footer>
      <Btn variant="light" @click="returnToNexcess">
        {{ $t("global.return-to-nexcess") }}
      </Btn>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import Logo from "@/components/display/Logo";
import Modal from "@/components/display/Modal";

export default {
  name: "FreeTrialApologyModal",
  components: {
    Modal,
    Btn,
    Logo,
  },
  setup() {
    const returnToNexcess = () => {
      window.location.href = "https://www.nexcess.net/";
    };

    return { returnToNexcess };
  },
};
</script>
